import Joi from '@hapi/joi'

export const RSMEmployeeDetailsReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Please select valid Estate`,
        "any.required": `Estate required`
    })
}